module.exports = __webpack_public_path__ + "img/percent-modified.81b42bdb.png";